function customSearch() {
    document.addEventListener("DOMContentLoaded", function () {

        const togglerAriaPressed = document.getElementById('modalSearchButton');

        if (togglerAriaPressed) {


            const toggleBtn = document.getElementById('modalSearchButton').querySelector('i');

            function toggleBtnModal() {

                if (toggleBtn.classList.contains('icon-suche')) {
                    togglerAriaPressed.setAttribute("aria-pressed", "true");
                    toggleBtn.classList.remove('icon-suche');
                    toggleBtn.classList.add('icon-plus');

                } else {
                    togglerAriaPressed.setAttribute("aria-pressed", "false");
                    toggleBtn.classList.remove('icon-plus');
                    toggleBtn.classList.add('icon-suche');
                }
            }

            function resetBtnIcon() {
                togglerAriaPressed.setAttribute("aria-pressed", "false");
                toggleBtn.classList.remove('icon-plus');
                toggleBtn.classList.add('icon-suche');
            }

            const myModalEl = document.getElementById('modalSearch');

            myModalEl.addEventListener('hidden.bs.modal', function () {
                resetBtnIcon();
            });

            myModalEl.addEventListener('show.bs.modal', function () {
                toggleBtnModal()
            });
        }

    });
}

export default customSearch;